import { useContext, useEffect, useRef } from 'react';
import { AuthContext, AuthContextState } from '../context/AuthContext';

export interface PublicRouteProps {
  children: JSX.Element
};

// wrapper for public routes that require an auth state check
const PublicRoute = (props: PublicRouteProps): JSX.Element | null => {
  const { authState, checkAuthenticated, fetchMe } = useContext(AuthContext) as AuthContextState;
  const authFuncCalled = useRef<boolean>(false);

  useEffect(() => {
    if (authFuncCalled.current) {
      return;
    }

    authFuncCalled.current = true
    if (!authState) {
      checkAuthenticated().then(
        (value: boolean) => {
          if (value) {
            fetchMe();
          }
        }
      );
    }
  }, [authState, checkAuthenticated, fetchMe, authFuncCalled]);

  return props.children;
};

export default PublicRoute;
